<div class="card card-custom gutter-b card-fit">
    <div class="card-header card-header-tabs-line">
        <div class="card-toolbar">
            <ul class="nav nav-tabs nav-bold nav-tabs-line">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': info }" data-toggle="tab" href="#pills-info"
                        (click)="ver('info')">
                        <span class="nav-text">
                            History
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': physical }" id="pills-physical-tab" data-toggle="tab"
                        data-bs-target="#pills-physical" href="#pills-physical" (click)="ver('physical')">
                        Suggestions
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': parameters }" id="pills-parameters-tab" data-toggle="tab"
                        data-bs-target="#pills-parameters" href="#pills-parameters" (click)="ver('parameters')">
                        Prescriptions
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{ 'active': treatments }" id="pills-treatments-tab" data-toggle="tab"
                        data-bs-target="#pills-treatments" href="#pills-treatments" (click)="ver('treatments')">
                        Treatments
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="tab-content">
        <div class="tab-pane fade" [ngClass]="{ 'show active': info }" id="pills-info" role="tabpanel"
            aria-labelledby="pills-info-tab">

            <div class="card-body mt-0 pt-4" *ngIf="filtering">
                <span *ngIf="petService.pet_histories_filter.length === 0">No information available</span>
                <div class="search-results" *ngIf="petService.pet_histories_filter.length > 0">
                    <div class="table-responsive max-h-500px">
                        <table class="table table-bordered  table-sm rounded">
                            <thead class="thead-light">
                                <tr>
                                    <th>
                                        Description
                                        <i *ngIf="petService.histories_order === 5"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 6"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Date Done
                                        <i *ngIf="petService.histories_order === 1"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 2"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Date Inv
                                        <i *ngIf="petService.histories_order === 3"
                                            class="fas fa-sort-amount-down-alt icon-sm"></i>
                                        <i *ngIf="petService.histories_order === 4"
                                            class="fas fa-sort-amount-down icon-sm"></i>
                                    </th>
                                    <th>
                                        Response
                                    </th>
                                    <th class="text-center">
                                        Req Done
                                    </th>
                                    <th class="text-center">
                                        Unit
                                    </th>
                                    <th class="text-right">
                                        Price
                                    </th>
                                    <th>
                                        Route
                                    </th>
                                    <th class="text-center">
                                        Admin Loc
                                    </th>
                                    <th>
                                        Clinic
                                    </th>
                                </tr>
                            </thead>
                            <tbody *ngFor="let item of petService.pet_histories_filter; let i = index">
                                <tr [ngStyle]="{'background-color': i % 2 === 0 ? '#EBEDF3' : '' }">
                                    <td>
                                        {{ item.procedure_desc }}
                                    </td>
                                    <td>
                                        {{ item.done_date }}
                                    </td>
                                    <td>
                                        {{ item.inv_date }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.response1 }}/{{ item.response2 }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.req_employee_initial | uppercase }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.unit }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.cost | currency }}
                                    </td>
                                    <td class="text-center">
                                        {{ item.location }}
                                    </td>
                                    <td>
                                        {{ item.route }}
                                    </td>
                                    <td>
                                        {{ item.clinic_abbrev }}
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="show_detail && (petService.pet_subhistories | subhistory:item.history_sequence).length > 0">
                                    <td></td>
                                    <td colspan="9">
                                        <table class="table table-sm table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Description
                                                    </th>
                                                    <th>
                                                        Unit
                                                    </th>
                                                    <th>
                                                        Method of Issue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let subitem of petService.pet_subhistories | subhistory:item.history_sequence">
                                                    <td>
                                                        {{ subitem.procedure_desc }}
                                                    </td>
                                                    <td>
                                                        {{ subitem.unit }}
                                                    </td>
                                                    <td>
                                                        {{ subitem.method_of_issue }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="card-body mt-0 pt-4" *ngIf="!filtering">

                <span *ngIf="petService.pet_histories.length === 0">No information available</span>
                <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                    (scrolled)="onScroll()" [scrollWindow]="false" *ngIf="petService.pet_histories.length > 0">
                    <table class="table table-bordered  table-sm rounded">
                        <thead>
                            <tr>
                                <th>
                                    Description
                                    <i *ngIf="petService.histories_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.histories_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Date Inv
                                    <i *ngIf="petService.histories_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.histories_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Response
                                </th>
                                <th>
                                    Req Done
                                </th>
                                <th>
                                    Unit
                                </th>
                                <th>
                                    Price
                                </th>
                                <th>
                                    Route
                                </th>
                                <th>
                                    Admin Location
                                </th>
                                <th>
                                    Clinic
                                </th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of petService.pet_histories; let i = index">
                            <tr [ngStyle]="{'background-color': i % 2 === 0 ? '#EBEDF3' : '' }">
                                <td>
                                    {{ item.procedure_desc (item.code) }}
                                </td>
                                <td>
                                    {{ item.done_date }}
                                </td>
                                <td>
                                    {{ item.inv_date }}
                                </td>
                                <td>
                                    {{ item.response1 }}/{{ item.response2 }}
                                </td>
                                <td>
                                    {{ item.req_employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.unit }}
                                </td>
                                <td>
                                    {{ item.cost | currency }}
                                </td>
                                <td>
                                    {{ item.location }}
                                </td>
                                <td>
                                    {{ item.route }}
                                </td>
                                <td>
                                    {{ item.clinic_abbrev }}
                                </td>
                            </tr>
                            <tr
                                *ngIf="show_detail && (petService.pet_subhistories | subhistory:item.history_sequence).length > 0">
                                <td></td>
                                <td colspan="9">
                                    <table class="table table-sm table-striped">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Description
                                                </th>
                                                <th>
                                                    Unit
                                                </th>
                                                <th>
                                                    Method of Issue
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let subitem of petService.pet_subhistories | subhistory:item.history_sequence">
                                                <td>
                                                    {{ subitem.procedure_desc }}
                                                </td>
                                                <td>
                                                    {{ subitem.unit }}
                                                </td>
                                                <td>
                                                    {{ subitem.method_of_issue }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="card-footer text-right py-5" *ngIf="petService.pet_histories.length > 0">

                <div class="dropdown" style="position: absolute !important;">
                    <button class="btn btn-sm btn-info mr-2 font-weight-bold dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-sort-alpha-down icon-sm"></i>
                        Sort
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="order(1)">ASC Date Done</a>
                        <a class="dropdown-item" (click)="order(2)">DESC Date Done</a>
                        <a class="dropdown-item" (click)="order(3)">ASC Date Inv</a>
                        <a class="dropdown-item" (click)="order(4)">DESC Date Inv</a>
                        <a class="dropdown-item" (click)="order(5)">ASC Description</a>
                        <a class="dropdown-item" (click)="order(6)">DESC Description</a>
                    </div>
                </div>

                <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold"
                    (click)="filter(1, tree.treeModel)">
                    <i class="fas fa-filter icon-sm"></i>
                    Filter
                </button>

                <button type="button" class="btn btn-sm mr-2 font-weight-bold"
                    [ngClass]="show_detail ? 'btn-info' : 'btn-secondary'" (click)="!show_detail = !show_detail">
                    <i *ngIf="!show_detail" class="fas fa-eye icon-sm"></i>
                    <i *ngIf="show_detail" class="fas fa-eye-slash icon-sm"></i>
                    Sub History
                </button>

                <button type="submit" class="btn btn-sm btn-primary">
                    Print
                </button>
            </div>

        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': physical }" id="pills-physical" role="tabpanel"
            aria-labelledby="pills-physical-tab">

            <div class="card-body mt-0 pt-4">

                
                <div class="table-responsive" style="height: 40vh;" *ngIf="petService.pet_suggestions.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>
                                    Date Suggested
                                </th>
                                <th>
                                    What was Suggested
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="petService.pet_suggestions.length === 0">
                                <td colspan="2">No information available</td>    
                            </tr>
                            <tr *ngFor="let item of petService.pet_suggestions">
                                <td>
                                    {{ item.suggest_date }}
                                </td>
                                <td>
                                    {{ item.procedure_desc }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="card-footer text-right py-4" *ngIf="petService.pet_suggestions.length > 0">

                <button type="submit" class="btn btn-primary">
                    Print
                </button>
            </div>

        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': parameters }" id="pills-parameters" role="tabpanel"
            aria-labelledby="pills-parameters-tab">

            <div class="card-body mt-0 pt-4" *ngIf="filtering_presc">

                <span *ngIf="petService.pet_prescriptions_filter.length === 0">No information available</span>
                <div class="table-responsive" style="height: 40vh;" *ngIf="petService.pet_prescriptions_filter.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;">
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.prescription_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Product Name
                                    <i *ngIf="petService.prescription_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Doctor
                                </th>
                                <th>
                                    Units
                                </th>
                                <th>
                                    #Rfl
                                </th>
                                <th>
                                    Rfl Exp
                                </th>
                                <th>
                                    Instructions
                                </th>
                                <th>
                                    Subst.
                                </th>
                                <th style="width: 10%;">
                                    Status
                                    <i *ngIf="petService.prescription_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of petService.pet_prescriptions_filter | prescription:selectedTreeList | orderhistory:petService.prescription_order"
                                (click)="selectPresc(item)"
                                [ngClass]="{'table-active': selectedPrescription === item}">
                                <td class="text-center">
                                    <i class="fas fa-edit text-primary" style="cursor: pointer;" (click)="updatePresc(item); $event.stopPropagation();"></i>
                                </td>
                                <td>
                                    {{ item.drug_note_date }}
                                </td>
                                <td>
                                    {{ item.product_name | uppercase }}
                                </td>
                                <td>
                                    {{ item.employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.units }}
                                </td>
                                <td>
                                    {{ item.refill_count }}
                                </td>
                                <td>
                                    {{ item.refill_expire }}
                                </td>
                                <td>
                                    {{ item.instructions }}
                                </td>
                                <td>
                                    {{ item.allow_generic === "True" ? 'YES' : 'NO' }}
                                </td>
                                <td>
                                    {{ item.in_clinic === 'True' ? 'Disp.' : 'Writ.' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>

            <div class="card-body mt-0 pt-4" *ngIf="!filtering_presc">

                <span *ngIf="petService.pet_prescriptions.length === 0">No information available</span>
                <div class="table-responsive" style="height: 40vh;" *ngIf="petService.pet_prescriptions.length > 0">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;">                                    
                                </th>
                                <th>
                                    Date Done
                                    <i *ngIf="petService.prescription_order === 1"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 2"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Product Name
                                    <i *ngIf="petService.prescription_order === 3"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 4"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                                <th>
                                    Doctor
                                </th>
                                <th>
                                    Units
                                </th>
                                <th>
                                    #Rfl
                                </th>
                                <th>
                                    Rfl Exp
                                </th>
                                <th>
                                    Instructions
                                </th>
                                <th>
                                    Subst.
                                </th>
                                <th style="width: 10%;">
                                    Status
                                    <i *ngIf="petService.prescription_order === 5"
                                        class="fas fa-sort-amount-down-alt icon-sm"></i>
                                    <i *ngIf="petService.prescription_order === 6"
                                        class="fas fa-sort-amount-down icon-sm"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of petService.pet_prescriptions | prescription:selectedTreeList | orderhistory:petService.prescription_order"
                                (click)="selectPresc(item)"
                                [ngClass]="{'table-active': selectedPrescription === item}">
                                <td class="text-center">
                                    <i class="fas fa-edit text-primary" style="cursor: pointer;" (click)="updatePresc(item); $event.stopPropagation();"></i>
                                </td>
                                <td>
                                    {{ item.drug_note_date }}
                                </td>
                                <td>
                                    {{ item.product_name | uppercase }}
                                </td>
                                <td>
                                    {{ item.employee_initial | uppercase }}
                                </td>
                                <td>
                                    {{ item.units }}
                                </td>
                                <td>
                                    {{ item.refill_count }}
                                </td>
                                <td>
                                    {{ item.refill_expire }}
                                </td>
                                <td>
                                    {{ item.instructions }}
                                </td>
                                <td>
                                    {{ item.allow_generic === "True" ? 'YES' : 'NO' }}
                                </td>
                                <td>
                                    {{ item.in_clinic === 'True' ? 'Disp.' : 'Writ.' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="card-footer text-right py-4" *ngIf="petService.pet_prescriptions.length > 0">
                <div class="text-left mb-2" *ngIf="selectedPrescription">
                    <small class="text-info">
                        <i class="fas fa-check-circle"></i> 
                        Selected: {{ selectedPrescription.product_name }} ({{ selectedPrescription.drug_note_date }})
                    </small>
                </div>

                <div class="dropdown" style="position: absolute !important;">
                    <button class="btn btn-sm btn-info mr-2 font-weight-bold dropdown-toggle" type="button"
                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-sort-alpha-down icon-sm"></i>
                        Sort
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" (click)="presOrder(1)">ASC Date Done</a>
                        <a class="dropdown-item" (click)="presOrder(2)">DESC Date Done</a>
                        <a class="dropdown-item" (click)="presOrder(3)">ASC Product Name</a>
                        <a class="dropdown-item" (click)="presOrder(4)">DESC Product Name</a>
                        <a class="dropdown-item" (click)="presOrder(5)">ASC Status</a>
                        <a class="dropdown-item" (click)="presOrder(6)">DESC Status</a>
                    </div>
                </div>

                <button type="button" class="btn btn-sm  btn-secondary mr-2 font-weight-bold"
                    (click)="filter(3, tree.treeModel)">
                    <i class="fas fa-filter icon-sm"></i>
                    Filter
                </button>

                <button type="button" class="btn btn-sm btn-primary" (click)="printPrescription()">
                    Print
                </button>
            </div>

        </div>
        <div class="tab-pane fade" [ngClass]="{ 'show active': treatments }" id="pills-treatments" role="tabpanel"
            aria-labelledby="pills-treatments-tab">
            <ngx-work-treatment-plan [pet_no]="pet_no"></ngx-work-treatment-plan>
        </div>
    </div>
</div>


<div class="modal fade" id="modalFilterHistory" tabindex="-1" role="dialog" aria-labelledby="modalFilterHistoryLabel"
    aria-hidden="true" (hidden.bs.modal)="onModalClose()">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <form (ngSubmit)="apply(tree.treeModel)" #formFilter="ngForm">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Filter</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose()">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="search-filter">
                        <div class="row" *ngIf="id_filter !== 3">
                            <div class="col">
                                <div class="form-group">
                                    <label>Code:</label>
                                    <select class="form-control" id="selectedTreeList1" name="_code" [(ngModel)]="code">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList1" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>Category:</label>
                                    <select class="form-control" id="selectedTreeList2" name="_category"
                                        [(ngModel)]="category" (change)="chgCategory()">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList2" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col" *ngIf="selectedTreeList3 && selectedTreeList3.length > 0">
                                <div class="form-group">
                                    <label>Subcategory:</label>
                                    <select class="form-control" id="selectedTreeList3" name="_subcategory"
                                        [(ngModel)]="subcategory">
                                        <option value=""></option>
                                        <option *ngFor="let item of selectedTreeList3" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{ id_filter === 3 ? 'Instruccions' : 'Description' }}:</label>
                                    <input type="text" class="form-control" name="_description" [(ngModel)]="description" />        
                                </div>    
                            </div>                   
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Select Items:</label>
                                    <div class="tree-container">
                                        <tree-root #tree [nodes]="nodes" [options]="options">

                                            <ng-template #treeNodeFullTemplate let-node let-index="index"
                                                let-templates="templates">
                                                <div class="tree-node">

                                                    <input type="checkbox" [checked]="node.isActive"
                                                        (change)="node.toggleActivated(true)" />

                                                    <tree-node-expander [node]="node"></tree-node-expander>

                                                    <div class="node-content-wrapper"
                                                        [class.node-content-wrapper-active]="node.isActive"
                                                        [class.node-content-wrapper-focused]="node.isFocused"
                                                        (click)="node.toggleActivated(true)">

                                                        <span [class]="node.data.className" [class.title]="true">
                                                            {{ node.data.name }}
                                                        </span>

                                                    </div>

                                                    <tree-node-children [node]="node"
                                                        [templates]="templates"></tree-node-children>
                                                </div>
                                            </ng-template>

                                        </tree-root>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn font-weight-bold btn-secondary mr-3" (click)="clear(tree.treeModel)">
                        <i class="fas fa-times icon-sm"></i>
                        Clear All
                    </button>
                    <button type="submit" class="btn font-weight-bold btn-primary">
                        <i class="fas fa-check icon-sm"></i>
                        Apply Filter
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>